module.exports = __webpack_public_path__ + "static/media/VI.59b50f2b.svg";